import { useCallback, useEffect, useState } from "react";

import {
  getVerificationResendCooldownRemaining,
  startVerificationResendCooldown,
  VERIFICATION_RESEND_COOLDOWN_SECONDS,
} from "@/lib/api/verification-resend-cooldown";

export function useVerificationResendCooldown(
  cooldownSeconds = VERIFICATION_RESEND_COOLDOWN_SECONDS,
) {
  const [secondsRemaining, setSecondsRemaining] = useState(() =>
    getVerificationResendCooldownRemaining(),
  );
  const isCoolingDown = secondsRemaining > 0;

  const start = useCallback(() => {
    setSecondsRemaining(startVerificationResendCooldown(cooldownSeconds));
  }, [cooldownSeconds]);

  useEffect(() => {
    if (!isCoolingDown) {
      return;
    }

    const timerId = window.setInterval(() => {
      setSecondsRemaining(getVerificationResendCooldownRemaining());
    }, 250);

    return () => {
      window.clearInterval(timerId);
    };
  }, [isCoolingDown]);

  return {
    secondsRemaining,
    isCoolingDown,
    start,
  };
}
